<template>
    <div>
        <div class="px-3">
            <div id="btn-open-caja" class="d-flex justify-content-end pt-2 my-2">
                <div class="btn-group btn-home" role="group">
                    <button type="button" class="btn btn-outline-main bg-main text-white" @click="returnHome">
                        <i class="fas fa-home"></i> Inicio
                    </button>
                </div>
            </div>
            <div class="row row-home  " id="div_conte_2">
                <div id="div_conte-home" class="col-md-10 mx-auto mt-0 border border-2 rounded rounded-2 border-main">
                    <div class="  bg-opacity-10">
                        <div class="text-center py-4 px-5">
                            <div class=" row row-home">
                                <div class=" border-main card-book border border-2 card div-pointer col m-2 p-2  "
                                    @click="changePage('medicamentos')">
                                    <div class="card-body">
                                        <h5 class="card-title color-main text-uppercase">Óptica</h5>
                                        <div class="icon-book">
                                            <img src="../../../../assets/lentes.png" alt=""
                                                class="img-fluid-bed-sop rounded-start">
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class=" border-main card-book border border-2 card div-pointer col m-2 p-2  "
                                    @click="changePage('activos')">
                                    <div class="card-body">
                                        <h5 class="card-title color-main text-uppercase">Activos</h5>
                                        <div class="icon-book">
                                            <img src="../../../../assets/actives.png" alt=""
                                                class="img-fluid-bed-sop rounded-start">
                                        </div>
                                    </div>

                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'homeMovimientos',
    data() {
        return {
            page: null
        }
    },
    methods: {
        changePage(page) {
            this.$emit('changePage', page)
        },
        returnHome: function () {
            this.$emit('returnHome')
        }
    }
}
</script>